import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {

  private readonly currentVersion =
    document
      .querySelector('meta[name="build-version"]')
      ?.getAttribute('content');

  start(intervalMs = 30000) {
    setInterval(() => {
      fetch('/index.html', { cache: 'no-store' })
        .then(res => res.text())
        .then(html => {
          const match = html.match(
            /meta name="build-version" content="(.*?)"/
          );

          if (match && match[1] && match[1] !== this.currentVersion) {
            console.log(
              `Nova versão detectada (${match[1]}). Recarregando...`
            );
            window.location.reload();
          }
        })
        .catch(() => {
          /* falha silenciosa */
        });
    }, intervalMs);
  }
}